import format from 'date-fns/format';
export var eventLocalTime = function eventLocalTime() {
  return {
    'event:localHour': parseInt(format(new Date(), 'H'), 10),
    'event:localDayOfWeek': parseInt(format(new Date(), 'i'), 10)
  };
};